<template>
    <li >
        <router-link :to="link" class="link link--kale magic-hover magic-hover__square">
            <img class="svg" :src="icon" :alt="text" />
            <span class="menu_content">
                {{text}}
            </span>
        </router-link>
    </li>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    icon: String,
    link: String,
    style: String,
    text: String,
  },
})
export default class MenuItem extends Vue {
    icon!: string;
    link!: string;
    style!: string;
    text!: string;
}
</script>

<style lang="scss" scoped>
.link {
    cursor: pointer;
    font-size: 18px;
    position: relative;
    white-space: nowrap;
    color: var(--color-text);
    margin: 0 auto 1rem 0;
    padding: 0 2rem 0 0.3rem;
    outline: 0 !important;
}

.link::before,
.link::after {
    position: absolute;
    width: 100%;
    height: 1px;
    background: currentColor;
    top: 100%;
    left: 0;
    pointer-events: none;
}
a {
    text-decoration: none;
    color: #efcf17;
    outline: none;
    clear: both;
    padding: 0;
    margin-bottom: 0;
    margin: 0px;
    // width: 100%;
    float: left;
    text-decoration: none;
    color: #767676;
    // display: inline-block;
    font-weight: 500;
    font-family: "Montserrat";
    transition: all 0.3s ease;
    cursor: pointer;
    .svg {
        display: none;
    }
}
a:hover {
  color: #000;
  // letter-spacing: 2px;
}
a.active {
  color: #000;
  // letter-spacing: 2px;
}

.link--kale {
text-transform: lowercase;
background-color: transparent;
}

.link--kale::before {
    content: '';
    height: 10px;
    color: #efcf17;
    top: 100%;
    opacity: 0;
}

.link--kale:hover::before {
    opacity: 1;
    animation: lineUp 0.3s ease forwards;
}

  @keyframes lineUp {
      0% {
          transform-origin: 50% 100%;
          transform: scale3d(1, 0.045, 1);
      }

      50% {
          transform-origin: 50% 100%;
          transform: scale3d(1, 1, 1);
      }

      51% {
          transform-origin: 50% 0%;
          transform: scale3d(1, 1, 1);
      }

      100% {
          transform-origin: 50% 0%;
          transform: scale3d(1, 0.045, 1);
      }
  }

  .link--kale::after {
      content: '';
      transition: opacity 0.3s;
      opacity: 0;
      transition-delay: 0s;
  }

  .active.link--kale::after {
    color: #000;
    opacity: 1;
  }

  .link--kale:hover::after {
      opacity: 1;
      transition-delay: 0.3s;
      color: #efcf17;
  }


.router-link-active.link--kale::after {
    opacity: 1;
    color: #ffef95;
    height: 13px;
    bottom: 0px;
    top: auto;
    z-index: -1;
    transition: all ease-in-out 0.2s;
}


.link--eirene {
    font-family: europa, sans-serif;
    font-weight: bold;
}

.link--eirene::before {
  content: '';
    height: 7px;
    border-radius: 20px;
    transform: scale3d(1, 1, 1);
    transition: transform 0.2s, opacity 0.2s;
    transition-timing-function: cubic-bezier(0.2, 0.57, 0.67, 1.53);
}

.link--eirene:hover::before {
    transition-timing-function: cubic-bezier(0.8, 0, 0.1, 1);
    transition-duration: 0.4s;
    opacity: 1;
    transform: scale3d(1.2, 0.1, 1);
}

.link--eirene span {
    transform: translate3d(0, -4px, 0);
    display: inline-block;
    transition: transform 0.2s 0.05s cubic-bezier(0.2, 0.57, 0.67, 1.53);
}

.link--eirene:hover span {
    transform: translate3d(0, 0, 0);
    transition-timing-function: cubic-bezier(0.8, 0, 0.1, 1);
    transition-duration: 0.4s;
    transition-delay: 0s;
}
</style>